import axios from 'axios';

import authManager from 'utils/authManager/authManager';

const axiosConfig = () => {
  axios.defaults.baseURL = import.meta.env.VITE_API_URL;
  axios.interceptors.request.use(config => {
    const token = authManager.getCookieAuthData()?.token;
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers = config.headers ?? {};
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `JWT ${token}`;
    } else if (config.headers) {
      // eslint-disable-next-line no-param-reassign
      delete config.headers.Authorization;
    }
    return config;
  });
  return axios;
};

const initWarehouseAxiosInstance = () =>
  axios.create({
    baseURL: import.meta.env.VITE_WAREHOUSE_API_URL,
  });

export { initWarehouseAxiosInstance };

export default axiosConfig;
